/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

export default reEscape;



// WEBPACK FOOTER //
// ./~/lodash-es/_reEscape.js